export const EVENTS_SCHEMA_VERSION = "0.44.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.17.0";
